import { useState, useEffect, useRef, useMemo } from 'react';

export default function useImagePreloader(itineraries = []) {
  const [loadedMap, setLoadedMap] = useState({});

  const started = useRef(new Set());

  const urls = useMemo(() => {
    return Array.from(
      new Set(itineraries
        .map(item => item.backgroundNode?.file?.httpsUrl || item.bgImageUrl)
        .filter(Boolean)
      )
    )
  }, [itineraries]);

  useEffect(() => {
    urls.forEach(url => {
      // skip if we already began loading this one
      if (started.current.has(url)) return;

      started.current.add(url);
      const img = new Image();
      img.onload = () => setLoadedMap(prev => ({ ...prev, [url]: true }));
      img.onerror = () => setLoadedMap(prev => ({ ...prev, [url]: false }));

      img.src = url;
    })
  }, [urls]);

  return loadedMap;
};